import React from 'react';
import {Input, Select, Typography} from 'antd';
import type {QuestionWithNewFields} from '../../Questions/QuestionTypes';

const {Text} = Typography;

export interface FillInTheBlanksEditorProps {
  question: QuestionWithNewFields;
  selectedBlankIndex: number;
  onSelectedBlankIndexChange: (index: number) => void;
  onChoiceValueChange: (
    blankIndex: number,
    choiceIndex: number,
    value: string,
  ) => void;
  onCorrectAnswerChange: (blankIndex: number, correctAnswer: string) => void;
  onAddChoice: (blankIndex: number) => void;
}

export const FillInTheBlanksEditor: React.FC<FillInTheBlanksEditorProps> = ({
  question,
  selectedBlankIndex,
  onSelectedBlankIndexChange,
  onChoiceValueChange,
  onCorrectAnswerChange,
}) => {
  const blanks = question.payload?.blanks || [];

  if (blanks.length === 0) {
    return (
      <div style={{marginTop: '20px', marginBottom: '20px'}}>
        <Text type="secondary">
          No BLANK keywords detected. Please add BLANK1, BLANK2, etc. to your
          question text.
        </Text>
      </div>
    );
  }

  const currentBlank = blanks[selectedBlankIndex];

  if (!currentBlank) {
    return (
      <div style={{marginTop: '20px', marginBottom: '20px'}}>
        <Text type="warning">Selected blank not found.</Text>
      </div>
    );
  }

  const answer = currentBlank.correctAnswer || currentBlank.choices?.[0] || '';

  const handleAnswerChange = (value: string) => {
    onChoiceValueChange(selectedBlankIndex, 0, value);
    onCorrectAnswerChange(selectedBlankIndex, value);
  };

  return (
    <div>
      <div style={{marginTop: '20px', marginBottom: '20px'}}>
        <Text style={{display: 'block'}}>Select Blank to Edit</Text>
        <Select
          value={selectedBlankIndex}
          showSearch
          style={{width: '30%'}}
          placeholder="Select a blank"
          optionFilterProp="children"
          onChange={(selectedIndex: number) =>
            onSelectedBlankIndexChange(selectedIndex)
          }>
          {blanks.map((blank, index) => (
            <Select.Option key={index} value={index}>
              {blank.name}
            </Select.Option>
          ))}
        </Select>
      </div>

      <div style={{marginTop: '10px', marginBottom: '10px'}}>
        <Text strong>Editing Blank: {currentBlank.name}</Text>
      </div>

      <div style={{marginTop: '20px', marginBottom: '20px'}}>
        <Text>Correct answer</Text>
        <Input
          value={answer}
          onChange={e => handleAnswerChange(e.target.value)}
          placeholder={`Correct answer for ${currentBlank.name}`}
        />
        {!answer.trim() && (
          <Text type="warning" style={{display: 'block', marginTop: '5px'}}>
            Correct answer is required <span style={{color: 'red'}}>*</span>
          </Text>
        )}
      </div>
    </div>
  );
};
